/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Deals_TitleInputs */

const en_directory_hubs_deals_title = /** @type {(inputs: Directory_Hubs_Deals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discount codes on software tools`)
};

const zh_directory_hubs_deals_title = /** @type {(inputs: Directory_Hubs_Deals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`软件工具折扣码`)
};

/**
* | output |
* | --- |
* | "Discount codes on software tools" |
*
* @param {Directory_Hubs_Deals_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_deals_title = /** @type {((inputs?: Directory_Hubs_Deals_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Deals_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_deals_title(inputs)
	return zh_directory_hubs_deals_title(inputs)
});
export { directory_hubs_deals_title as "directory.hubs.deals.title" }